import { render, staticRenderFns } from "./BookedInfoIcon.vue?vue&type=template&id=d2bd7d38&scoped=true&lang=html&"
import script from "./BookedInfoIcon.vue?vue&type=script&lang=js&"
export * from "./BookedInfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bd7d38",
  null
  
)

export default component.exports